import script from "./BFilterModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BFilterModal.vue?vue&type=script&setup=true&lang=ts"

import "./BFilterModal.vue?vue&type=style&index=0&id=6dd152b8&lang=css"

const __exports__ = script;

export default __exports__